document.addEventListener('DOMContentLoaded', () => {
    // 1. Create Modal HTML if it doesn't exist yet
    if (!document.getElementById('bioModal')) {
        const modalHTML = `
            <div id="bioModal" class="hidden" role="dialog" aria-modal="true">
                <div class="modal-backdrop" data-modal-close></div>
                <div id="bioModalPanel">
                    <button class="modal-close-btn" data-modal-close aria-label="Close">&times;</button>
                    <div class="modal-inner">
                        <h3 id="bioModalTitle" class="modal-title"></h3>
                        <div id="bioModalContent" class="modal-body"></div>
                    </div>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', modalHTML);
    }

    const modal = document.getElementById('bioModal');
    const panel = document.getElementById('bioModalPanel');
    const titleEl = document.getElementById('bioModalTitle');
    const contentEl = document.getElementById('bioModalContent');

    function openModal(title, content) {
        titleEl.textContent = title;
        contentEl.innerHTML = content;
        modal.classList.remove('hidden');
        setTimeout(() => panel.classList.add('active'), 10);
        document.body.style.overflow = 'hidden';
    }

    function closeModal() {
        panel.classList.remove('active');
        setTimeout(() => {
            modal.classList.add('hidden');
            document.body.style.overflow = '';
        }, 300);
    }

    // 2. Delegate Event Listeners (Efficient for dynamic content)
    document.addEventListener('click', function (e) {
        const openBtn = e.target.closest('.js-bio-btn');
        if (openBtn) {
            e.preventDefault();
            const card = openBtn.closest('[data-member-card]');
            const name = card.querySelector('[data-member-name]').textContent;
            const bio  = card.querySelector('[data-member-bio]').innerHTML;
            openModal(name, bio);
        }
        if (e.target.closest('[data-modal-close]')) {
            closeModal();
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.classList.contains('hidden')) closeModal();
    });
});